import { createContext, useContext, useState } from 'react'

interface ExportModalContextType {
  isModalOpen: boolean
  modalKey: string | null
  openModal: (key: string) => void
  closeModal: () => void
}

export const ExportModalContext = createContext<ExportModalContextType>({
  isModalOpen: false,
  modalKey: null,
  openModal: () => {},
  closeModal: () => {},
})

export const useExportModal = (): ExportModalContextType => {
  return useContext(ExportModalContext)
}

export const ExportModalConsumer = ExportModalContext.Consumer

export const ExportModalProvider = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const [state, setState] = useState<{ open: boolean; key: string | null }>({
    open: false,
    key: null,
  })

  const openModal = (key: string) =>
    setState({
      open: true,
      key,
    })
  const closeModal = () => setState({ open: false, key: null })

  return (
    <ExportModalContext.Provider
      value={{
        isModalOpen: state.open,
        modalKey: state.key,
        openModal,
        closeModal,
      }}
    >
      {children}
    </ExportModalContext.Provider>
  )
}
